var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('a-modal',{staticClass:"set-user-password",attrs:{"title":_vm.modalTitle,"ok-text":_vm.$t('accept'),"after-close":_vm.afterModalClose,"ok-button-props":{
      props: {
        disabled: invalid || !_vm.arePasswordsEqualVm
      }
    }},on:{"ok":_vm.changePasswordVm},model:{value:(_vm.isModalOpen),callback:function ($$v) {_vm.isModalOpen=$$v},expression:"isModalOpen"}},[(_vm.hasPassword)?_c('password-input',{staticClass:"mt-0",attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.passwordModel,
          'key': 'current',
          'prefix': 'password_',
          'autocomplete': 'new-password',
          'validation': ("required|min:" + _vm.PASSWORD_MIN_SYMBOLS),
          'supportButtons': false
        },
      }}}):_vm._e(),_c('new-password-fields',{attrs:{"password":_vm.passwordModel.target,"confirm-password":_vm.passwordModel.confirmTarget,"are-passwords-equal":_vm.arePasswordsEqualVm},on:{"update:password":function($event){return _vm.$set(_vm.passwordModel, "target", $event)},"update:confirmPassword":function($event){return _vm.$set(_vm.passwordModel, "confirmTarget", $event)},"update:confirm-password":function($event){return _vm.$set(_vm.passwordModel, "confirmTarget", $event)}}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }